import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { MyListApi } from "../utils/restApi";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

export const UserValidation = () => {

    const validationUser = window.localStorage.getItem('validation-user');
    // const validationStatus = window.localStorage.getItem('validation-status');

    // const { email, validationCode } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const spUsername = searchParams.get("username");
    const spValidationCode = searchParams.get("validation_code");
    const [username, setUsername] = useState(spUsername || validationUser || '');
    const [validationCode, setValidationCode] = useState(spValidationCode || '');

    const validateDisabled = !username || !validationCode;

    const handleValidate = () => {
        MyListApi.userValidation(username, validationCode)
            .then(data => {
                dispatch(addNotification({
                    message: 'User successfully validated!',
                    type: 'success'
                }));
                navigate('/login');
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            })
    }

    const handleNewCode = () => {
        MyListApi.newUserValidation(username)
            .then(_ => {
                dispatch(addNotification({
                    message: 'A new validation code has been sent. Check your email.',
                    type: 'success',
                }));
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    const handleUsername = e => {
        setUsername(e.target.value);
    }

    const handleValidationCode = e => {
        setValidationCode(e.target.value);
    }

    return (
        <Box>
            <Paper sx={{ padding: '20px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Typography variant="h6">Email Validation</Typography>
                    <Typography>Your validation code will expire within 5 minutes of the time it was generated.</Typography>
                    <TextField variant="filled" label="User Email" value={username} onChange={handleUsername} disabled />
                    <TextField variant='filled' label="Validation Code" value={validationCode} onChange={handleValidationCode} />
                    <Box sx={{ display: 'flex', gap: '10px' }}>
                        <Button variant="contained" onClick={handleValidate} disabled={validateDisabled}>Validate</Button>
                        <Button variant="contained" onClick={handleNewCode}>Get New Validation Code</Button>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
}